import 'rc-slider/assets/index.css'
import useTranslation from 'next-translate/useTranslation'
import Slider from 'rc-slider'
import { useEffect, useState } from 'react'

export const DEFAULT_LOOP = 1

const Loop = function ({ disabled = false, onChange, min, max, marks }) {
  const { t } = useTranslation()
  const [loop, setLoop] = useState(DEFAULT_LOOP)
  const [inputValue, setInputValue] = useState(DEFAULT_LOOP)
  const [invalidInput, setInvalidInput] = useState(false)
  const validationRegex = /^\d*\.?\d*$/

  useEffect(
    function () {
      onChange?.(loop)
    },
    [loop, onChange]
  )

  useEffect(
    function () {
      setInputValue(loop)
      setInvalidInput(false)
    },
    [loop]
  )

  const handleInputChange = function (e) {
    e.preventDefault()
    if (!validationRegex.test(e.target.value)) {
      setInputValue('')
      setLoop(DEFAULT_LOOP)
    } else {
      setInputValue(e.target.value)
      if (e.target.value < min || e.target.value > max) {
        setInvalidInput(true)
      } else {
        setLoop(
          e.target.value.startsWith('.') ? `0${e.target.value}` : e.target.value
        )
      }
    }
  }

  return (
    <div
      className={`bg-blue-secondary rounded-lg p-4 pb-6 pr-6 ${
        disabled ? 'opacity-20' : ''
      }`}
    >
      <span className="text-lg font-medium">{t('set-loop')}</span>
      <div className="mt-6 flex space-x-6">
        <div
          className={`${
            invalidInput
              ? 'bg-state-bg-error text-state-error'
              : 'bg-teal-primary-0.2 text-teal-primary'
          } w-16 rounded py-2 text-center text-sm`}
        >
          <input
            className={`w-8 bg-transparent text-right focus-visible:outline-none`}
            data-sentry="loop-custom"
            inputMode="numeric"
            max={max}
            min={min}
            onChange={handleInputChange}
            size={1}
            step="0.01"
            value={inputValue}
          />
          x
        </div>
        <div className="flex w-full items-center">
          <Slider
            className="!bg-transparent text-white"
            disabled={disabled}
            dotStyle={{
              backgroundColor: '#259DA8',
              border: 'none',
              bottom: '0',
              height: '4px',
              width: '4px'
            }}
            dots
            handleStyle={{
              backgroundColor: '#259DA8',
              border: '4px solid #FFFFFF',
              boxShadow: 'none',
              height: '24px',
              marginTop: '-10px',
              opacity: '1',
              width: '24px'
            }}
            marks={marks}
            max={max}
            min={min}
            onChange={val => setLoop(val)}
            step="0.01"
            trackStyle={{ backgroundColor: '#259DA8' }}
            value={loop}
          />
        </div>
      </div>
    </div>
  )
}

export default Loop
